import useMutation from "../useMutation";

function useWTCodeScanExport(id) {
  return useMutation({
    path: `/api/v1/warehouse-transfers/${id}/transfer-details/transferDetailId/export`,
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/warehouse-transfers/${id}`,
      shouldRevalidate: true,
    },
  });
}

export default useWTCodeScanExport;
